export const triggerSequences = [
    {
        id: 'SOS_PHYSICAL_BTN',
        label: 'Bouton SOS physique',
        type: 'man',
        hasConfig: true,
    },
    {
        id: 'TOUCH_SCREEN',
        label: 'Ecran tactile',
        type: 'man',
        hasConfig: true,
    },
    {
        id: 'KEY_COMBINATION',
        label: 'Combinaison de touches (non disponible)',
        type: 'man',
    },
    {
        id: 'LACK_OF_MOVEMENT',
        label: 'Absence de mouvement',
        type: 'auto',
        hasConfig: true,
    },
    {
        id: 'LOSS_OF_VERTICALITY',
        label: 'Perte soudaine de verticalité (non disponible)',
        type: 'auto',
        hasConfig: true,
    },
    {
        id: 'BREADCRUMB',
        label: 'Ligne de vie',
        type: 'auto',
        hasConfig: true,
    },
    {
        id: 'AGRESSION_PHYSICAL_BTN',
        label: 'Agression',
        type: 'man',
    },
];
